module.exports = __webpack_public_path__ + "img/news-3.13f31bb7.jpg";